__turbopack_context__.v({
  "btnContainer": "ClientSideButton-module-scss-module__REaO4W__btnContainer",
  "btnText": "ClientSideButton-module-scss-module__REaO4W__btnText",
});
